import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const PendingApInvoices = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div class="row mx-0">
                  <div class="shadowclass">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert"> Pending AP Invoices </h4>
                        <div class="row justify-content-between">
                          <div class="col-md-4">
                            <div class="search-box">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div className="table-responsive">
                            <table className="checklist-table">
                              <thead>
                                <tr>
                                  <th>
                                    <a class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        name="master_check"
                                        class="avail_checkbox"
                                        value=""
                                        id="checkbox_order_id"
                                      />
                                      <label for="checkbox_order_id"></label>
                                    </a>
                                  </th>
                                  <th> ID </th>
                                  <th className="min-wd-150">Payee</th>
                                  <th className="min-wd-150">Contact</th>
                                  <th>Total</th>
                                  <th>OCR Match</th>
                                  <th> Actions </th>
                                  <th class="text-right">
                                    <button
                                      id="verify_selected"
                                      type="submit"
                                      class="btn btn_btnblue"
                                    >
                                      Verify Selected
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <a class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        name="ids[]"
                                        class="avail_checkbox child_box"
                                        value="15558"
                                        id="order_id_15558"
                                      />
                                      <label for="order_id_15558"> </label>
                                    </a>
                                  </td>
                                  <td> 15558 </td>
                                  <td>
                                    <strong> Ice Cream Scoop </strong>
                                    <br />
                                    Food - Dessert
                                  </td>
                                  <td>
                                    ankita.bhatt@xicom.biz;sandeep@xicom.biz
                                  </td>
                                  <td> $1,276.00 </td>
                                  <td> </td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="#_"
                                        class="circle_icon edit_tooltip"
                                      >
                                        <i class="iconSprites edit-icon"></i>
                                      </a>
                                      <a
                                        href="#_"
                                        title="View"
                                        class="circle_icon"
                                      >
                                        <i class="iconSprites eye-icon"></i>
                                      </a>
                                      <a
                                        class="circle_icon red reject_invoice"
                                        val="68"
                                        title="Reject"
                                        href="#_"
                                      >
                                        <i class="iconSprites cancel-icon"></i>
                                      </a>
                                    </div>
                                  </td>
                                  <td class="align-right">
                                    <button
                                      type="button"
                                      class="btn btn_btnblue verify"
                                    >
                                      Verify
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default PendingApInvoices;
